import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

class Home {
  constructor () {
    this.init()
  }

  init () {
    function searchSwiper () {
      const swiper = new Swiper('.swiper-search', {
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        spaceBetween: 15,
        breakpoints: {
          768: {
            spaceBetween: 10
          }
        }
      })
    }

    function searchSwiperActu () {
      const swiper = new Swiper('.swiper-search-actu', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        breakpoints: {
          768: {
            spaceBetween: 10
          }
        }
      })
    }

    function eventsSwiper () {
      const swiper = new Swiper('.swiper-events', {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination'
        }
      })
    }

    function actusSwiper () {
      const swiper = new Swiper('.swiper-actu', {
        modules: [Navigation, Pagination],
        slidesPerView: 1.1,
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination'
        },
        breakpoints: {
          564: {
            slidesPerView: 2,
            spaceBetween: 15
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30
          }
        }
      })
    }

    // Rejoindre Count
    $('.number-count').each(function () {
      const finalValue = parseInt($(this).text())
      const duration = 2000

      $(this).animate({ num: finalValue }, {
        duration,
        step: function (now) {
          $(this).text(Math.floor(now))
        },
        complete: function () {
          $(this).text(finalValue)
        }
      })
    })

    // Init swipper search mobile
    if ($('.swiper-search').length > 0) {
      searchSwiper()
    }

    if ($('.swiper-search-actu').length > 0) {
      searchSwiperActu()
    }

    // Init swipper events mobile
    let swiperEvents = null

    function handleEventsSwiper () {
      if ($(window).width() < 768 && $('.swiper-events').length > 0) {
        swiperEvents = eventsSwiper()

        if (swiperEvents) {
          if (typeof swiperEvents.update === 'function') {
            swiperEvents.update()
          }
        }
      } else {
        if (swiperEvents) {
          swiperEvents.destroy()
          swiperEvents = null
        }
      }
    }

    handleEventsSwiper()

    $(window).on('resize', handleEventsSwiper)

    // Events tabs active
    $('.event-list-item .event-item:first-child').addClass('active')
    $('.event-content:first-child').addClass('event-content-active')
    if ($('.event-list-item').length > 0) {
      $('.event-list-item .event-item').on('click', function () {
        const contentIndex = $(this).data('content')
        console.log(contentIndex)

        $('.event-list-item .event-item').removeClass('active')
        $(this).addClass('active')

        $('.event-content').removeClass('event-content-active')

        $('.event-content[data-content="' + contentIndex + '"]').addClass('event-content-active')
      })
    }

    // Init swipper events mobile
    actusSwiper()

    // Init swipper maillage
    if ($('.swiper-maillage').length > 0) {
      const swiper = new Swiper('.swiper-maillage', {
        modules: [Navigation, Pagination],
        slidesPerView: 1.1,
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          564: {
            slidesPerView: 2,
            spaceBetween: 15
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 30
          }
        }
      })
    }
  }
}

export default Home
